__turbopack_context__.v({
  "badge": "STWMeW_badge",
  "cartButton": "STWMeW_cartButton",
});
